import {Component, Input, OnInit} from '@angular/core';
import {Userdocument} from "../../userdocument";
import {Payement} from "../../../../bo/organization/payment";
import {EventsService} from "../../../../bo/events/events.service";
import {AccountService} from "../../account.service";
import {User} from "../../../../shared/login/user";

@Component({
  selector: 'app-payment-data-form',
  templateUrl: './payment-data-form.component.html',
  styleUrls: ['./payment-data-form.component.css']
})
export class PaymentDataFormComponent implements OnInit {

  passwordEmail = {email:'', password:''};
  incorrectPasswordError: boolean = false;
  loadingUnlockPassword: boolean = false;
  payment: Payement = new Payement();
  userDocument: Userdocument = new Userdocument();
  isRecto = true;
  ribBlocs: any =  {ribPassword : true,noRibAddRib :false,ribList:false,ribForm:false};
  confirmDocumentNotExpired = false;
  errors: any = [];
  payementErrors: any = [];
  @Input() user: User;
  constructor(private accountService: AccountService,private eventService: EventsService) { }

  setRibBloc(bloc) {
    for (let key in this.ribBlocs) {
      this.ribBlocs[key] = false;
    }
    this.ribBlocs[bloc] = true;
  }

  ribBlocIsVisible(bloc) {
    return this.ribBlocs[bloc];
  }

  goToRibBlocItem(bloc) {
    this.setRibBloc(bloc)
  }

  openDownloadIban() {
    let $ = window['jQuery'];
    $('#download_iban').click();
  }


  iban_bic_download_FileListenner($event) {
    let file: File = $event.target.files[0];
    let myReader: FileReader = new FileReader();
    let that = this;
    myReader.onloadend = function (loadEvent: any) {
      that.payment.rib_iban_pdf = loadEvent.target.result;
    };
    myReader.readAsDataURL(file);
  }

  createOrUpdatePayment(e) {
    e.preventDefault();
    e.stopPropagation();
    this.payment.devise = 'EUR';
    this.payment.user_id = this.user.id;
    this.accountService.createPayement(this.payment).then(res => {
      this.payment = res;
      this.goToRibBlocItem('ribList');
    });
  }
  static displayBic(bic) {
    let bicFormated = '';
    for (let i = 0; i < bic.length; i++) {
      if(i<=7) {
        bicFormated += bic[i];
      } else {
        bicFormated += 'X';
      }
    }
    return bicFormated;
  }
  static displayIban(iban) {
    let ibanFormated = '';
    for (let i = 0; i < iban.length; i++) {
      if(i>3 && i<14) {
        ibanFormated += 'X';
      } else {
        ibanFormated += iban[i];
      }
    }
    return ibanFormated;
  }
  unlockWithPassWord() {
    this.loadingUnlockPassword = true;
    this.passwordEmail.email = this.user.email;
    this.accountService.unlockWithPassWord(this.passwordEmail).then(res => {
      if(res === 'incorret') {
        this.loadingUnlockPassword = false;
        this.incorrectPasswordError = true;
      } else {
        this.loadingUnlockPassword = false;
        this.incorrectPasswordError = false;
        this.goToRibBlocItem('ribForm');
        /*if(res.organisation && res.organisation.id != 2 && res.organisation.payment) {
          this.payment = res.organisation.payment;
          this.goToRibBlocItem('ribList');
        } else {
          this.goToRibBlocItem('noRibAddRib');
        }*/
      }
    })
  }

  ngOnInit() {
   /* console.log(this.user);
    if (this.user.organisation && this.user.organisation.id != 2 && this.user.organisation.payment_id) {
       this.goToRibBlocItem('ribList');
     } else {
      this.goToRibBlocItem('noRibAddRib');
    }*/
    this.loadUserPayment();
  }

  loadUserPayment() {
    this.accountService.paymentInfo().then(res => {
      if(res && res.id) {
        this.payment = res;
        this.goToRibBlocItem('ribList');
      } else {
        this.goToRibBlocItem('noRibAddRib');
      }
    })
  }

  displayBic(bic) {
    let bicFormated = '';
    for (let i = 0; i < bic.length; i++) {
      if(i<=7) {
        bicFormated += bic[i];
      } else {
        bicFormated += 'X';
      }
    }
    return bicFormated;
  }
  displayIban(iban) {
    let ibanFormated = '';
    for (let i = 0; i < iban.length; i++) {
      if(i>3 && i<14) {
        ibanFormated += 'X';
      } else {
        ibanFormated += iban[i];
      }
    }
    return ibanFormated;
  }

  editRib() {
    this.goToRibBlocItem('ribPassword');
    this.accountService.loadUserPaymentInfo(this.user.id).then(res => {
      if(res && res.id) {
        this.payment = res;
        ///this.goToRibBlocItem('ribForm');
      }
    })
  }
}
